import { render, staticRenderFns } from "./NjangiChecklist.vue?vue&type=template&id=cc613656&scoped=true"
import script from "./NjangiChecklist.vue?vue&type=script&lang=js"
export * from "./NjangiChecklist.vue?vue&type=script&lang=js"
import style0 from "./NjangiChecklist.vue?vue&type=style&index=0&id=cc613656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc613656",
  null
  
)

export default component.exports